/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../core/routes/__root'
import { Route as modulesCoreRoutesMainUiIndexRouteImport } from './../../core/routes/_main-ui/index'
import { Route as modulesAuthRoutesAuthIndexRouteImport } from './../../auth/routes/_auth/index'
import { Route as modulesCoreRoutesProtectedIndexRouteImport } from './../../core/routes/_protected/index'
import { Route as modulesAuthRoutesLoginIndexRouteImport } from './../../auth/routes/login/index'
import { Route as modulesCoreRoutesHomeIndexRouteImport } from './../../core/routes/home/index'
import { Route as modulesPromotionsRoutesCreateIndexRouteImport } from './../../promotions/routes/create/index'
import { Route as modulesPromotionsRoutesDetailsIndexRouteImport } from './../../promotions/routes/details/index'
import { Route as modulesUserManagementRoutesHomeIndexRouteImport } from './../../user-management/routes/home/index'
import { Route as modulesPromotionsRoutesHomeIndexRouteImport } from './../../promotions/routes/home/index'
import { Route as modulesImportExportSettingsRoutesIndexIndexRouteImport } from './../../import-export-settings/routes/index/index'
import { Route as modulesEmailSettingsRoutesIndexIndexRouteImport } from './../../email-settings/routes/index/index'
import { Route as modulesDashboardSettingsRoutesDashboardIndexRouteImport } from './../../dashboard-settings/routes/dashboard/index'
import { Route as modulesAnalyticsRoutesIndexIndexRouteImport } from './../../analytics/routes/index/index'
import { Route as modulesPromotionsRoutesEditIndexRouteImport } from './../../promotions/routes/edit/index'
import { Route as modulesPromotionsRoutesDuplicateIndexRouteImport } from './../../promotions/routes/duplicate/index'

const modulesCoreRoutesMainUiIndexRoute =
  modulesCoreRoutesMainUiIndexRouteImport.update({
    id: '/_main-ui',
    getParentRoute: () => rootRouteImport,
  } as any)
const modulesAuthRoutesAuthIndexRoute =
  modulesAuthRoutesAuthIndexRouteImport.update({
    id: '/_auth',
    getParentRoute: () => rootRouteImport,
  } as any)
const modulesCoreRoutesProtectedIndexRoute =
  modulesCoreRoutesProtectedIndexRouteImport.update({
    id: '/_protected',
    getParentRoute: () => modulesCoreRoutesMainUiIndexRoute,
  } as any)
const modulesAuthRoutesLoginIndexRoute =
  modulesAuthRoutesLoginIndexRouteImport.update({
    id: '/auth/login',
    path: '/auth/login',
    getParentRoute: () => modulesAuthRoutesAuthIndexRoute,
  } as any)
const modulesCoreRoutesHomeIndexRoute =
  modulesCoreRoutesHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesPromotionsRoutesCreateIndexRoute =
  modulesPromotionsRoutesCreateIndexRouteImport.update({
    id: '/promotions/create',
    path: '/promotions/create',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesPromotionsRoutesDetailsIndexRoute =
  modulesPromotionsRoutesDetailsIndexRouteImport.update({
    id: '/promotions/$id',
    path: '/promotions/$id',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesUserManagementRoutesHomeIndexRoute =
  modulesUserManagementRoutesHomeIndexRouteImport.update({
    id: '/user-management/',
    path: '/user-management/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesPromotionsRoutesHomeIndexRoute =
  modulesPromotionsRoutesHomeIndexRouteImport.update({
    id: '/promotions/',
    path: '/promotions/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesImportExportSettingsRoutesIndexIndexRoute =
  modulesImportExportSettingsRoutesIndexIndexRouteImport.update({
    id: '/import-export-settings/',
    path: '/import-export-settings/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesEmailSettingsRoutesIndexIndexRoute =
  modulesEmailSettingsRoutesIndexIndexRouteImport.update({
    id: '/email-settings/',
    path: '/email-settings/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesDashboardSettingsRoutesDashboardIndexRoute =
  modulesDashboardSettingsRoutesDashboardIndexRouteImport.update({
    id: '/dashboard-settings/',
    path: '/dashboard-settings/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesAnalyticsRoutesIndexIndexRoute =
  modulesAnalyticsRoutesIndexIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesPromotionsRoutesEditIndexRoute =
  modulesPromotionsRoutesEditIndexRouteImport.update({
    id: '/promotions/edit/$id',
    path: '/promotions/edit/$id',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)
const modulesPromotionsRoutesDuplicateIndexRoute =
  modulesPromotionsRoutesDuplicateIndexRouteImport.update({
    id: '/promotions/duplicate/$id',
    path: '/promotions/duplicate/$id',
    getParentRoute: () => modulesCoreRoutesProtectedIndexRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof modulesCoreRoutesHomeIndexRoute
  '/auth/login': typeof modulesAuthRoutesLoginIndexRoute
  '/analytics': typeof modulesAnalyticsRoutesIndexIndexRoute
  '/dashboard-settings': typeof modulesDashboardSettingsRoutesDashboardIndexRoute
  '/email-settings': typeof modulesEmailSettingsRoutesIndexIndexRoute
  '/import-export-settings': typeof modulesImportExportSettingsRoutesIndexIndexRoute
  '/promotions': typeof modulesPromotionsRoutesHomeIndexRoute
  '/user-management': typeof modulesUserManagementRoutesHomeIndexRoute
  '/promotions/$id': typeof modulesPromotionsRoutesDetailsIndexRoute
  '/promotions/create': typeof modulesPromotionsRoutesCreateIndexRoute
  '/promotions/duplicate/$id': typeof modulesPromotionsRoutesDuplicateIndexRoute
  '/promotions/edit/$id': typeof modulesPromotionsRoutesEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof modulesCoreRoutesHomeIndexRoute
  '/auth/login': typeof modulesAuthRoutesLoginIndexRoute
  '/analytics': typeof modulesAnalyticsRoutesIndexIndexRoute
  '/dashboard-settings': typeof modulesDashboardSettingsRoutesDashboardIndexRoute
  '/email-settings': typeof modulesEmailSettingsRoutesIndexIndexRoute
  '/import-export-settings': typeof modulesImportExportSettingsRoutesIndexIndexRoute
  '/promotions': typeof modulesPromotionsRoutesHomeIndexRoute
  '/user-management': typeof modulesUserManagementRoutesHomeIndexRoute
  '/promotions/$id': typeof modulesPromotionsRoutesDetailsIndexRoute
  '/promotions/create': typeof modulesPromotionsRoutesCreateIndexRoute
  '/promotions/duplicate/$id': typeof modulesPromotionsRoutesDuplicateIndexRoute
  '/promotions/edit/$id': typeof modulesPromotionsRoutesEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof modulesAuthRoutesAuthIndexRouteWithChildren
  '/_main-ui': typeof modulesCoreRoutesMainUiIndexRouteWithChildren
  '/_main-ui/_protected': typeof modulesCoreRoutesProtectedIndexRouteWithChildren
  '/_main-ui/_protected/': typeof modulesCoreRoutesHomeIndexRoute
  '/_auth/auth/login': typeof modulesAuthRoutesLoginIndexRoute
  '/_main-ui/_protected/analytics/': typeof modulesAnalyticsRoutesIndexIndexRoute
  '/_main-ui/_protected/dashboard-settings/': typeof modulesDashboardSettingsRoutesDashboardIndexRoute
  '/_main-ui/_protected/email-settings/': typeof modulesEmailSettingsRoutesIndexIndexRoute
  '/_main-ui/_protected/import-export-settings/': typeof modulesImportExportSettingsRoutesIndexIndexRoute
  '/_main-ui/_protected/promotions/': typeof modulesPromotionsRoutesHomeIndexRoute
  '/_main-ui/_protected/user-management/': typeof modulesUserManagementRoutesHomeIndexRoute
  '/_main-ui/_protected/promotions/$id': typeof modulesPromotionsRoutesDetailsIndexRoute
  '/_main-ui/_protected/promotions/create': typeof modulesPromotionsRoutesCreateIndexRoute
  '/_main-ui/_protected/promotions/duplicate/$id': typeof modulesPromotionsRoutesDuplicateIndexRoute
  '/_main-ui/_protected/promotions/edit/$id': typeof modulesPromotionsRoutesEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/login'
    | '/analytics'
    | '/dashboard-settings'
    | '/email-settings'
    | '/import-export-settings'
    | '/promotions'
    | '/user-management'
    | '/promotions/$id'
    | '/promotions/create'
    | '/promotions/duplicate/$id'
    | '/promotions/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/login'
    | '/analytics'
    | '/dashboard-settings'
    | '/email-settings'
    | '/import-export-settings'
    | '/promotions'
    | '/user-management'
    | '/promotions/$id'
    | '/promotions/create'
    | '/promotions/duplicate/$id'
    | '/promotions/edit/$id'
  id:
    | '__root__'
    | '/_auth'
    | '/_main-ui'
    | '/_main-ui/_protected'
    | '/_main-ui/_protected/'
    | '/_auth/auth/login'
    | '/_main-ui/_protected/analytics/'
    | '/_main-ui/_protected/dashboard-settings/'
    | '/_main-ui/_protected/email-settings/'
    | '/_main-ui/_protected/import-export-settings/'
    | '/_main-ui/_protected/promotions/'
    | '/_main-ui/_protected/user-management/'
    | '/_main-ui/_protected/promotions/$id'
    | '/_main-ui/_protected/promotions/create'
    | '/_main-ui/_protected/promotions/duplicate/$id'
    | '/_main-ui/_protected/promotions/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  modulesAuthRoutesAuthIndexRoute: typeof modulesAuthRoutesAuthIndexRouteWithChildren
  modulesCoreRoutesMainUiIndexRoute: typeof modulesCoreRoutesMainUiIndexRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main-ui': {
      id: '/_main-ui'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof modulesCoreRoutesMainUiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof modulesAuthRoutesAuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main-ui/_protected': {
      id: '/_main-ui/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof modulesCoreRoutesProtectedIndexRouteImport
      parentRoute: typeof modulesCoreRoutesMainUiIndexRoute
    }
    '/_auth/auth/login': {
      id: '/_auth/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof modulesAuthRoutesLoginIndexRouteImport
      parentRoute: typeof modulesAuthRoutesAuthIndexRoute
    }
    '/_main-ui/_protected/': {
      id: '/_main-ui/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof modulesCoreRoutesHomeIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/promotions/create': {
      id: '/_main-ui/_protected/promotions/create'
      path: '/promotions/create'
      fullPath: '/promotions/create'
      preLoaderRoute: typeof modulesPromotionsRoutesCreateIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/promotions/$id': {
      id: '/_main-ui/_protected/promotions/$id'
      path: '/promotions/$id'
      fullPath: '/promotions/$id'
      preLoaderRoute: typeof modulesPromotionsRoutesDetailsIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/user-management/': {
      id: '/_main-ui/_protected/user-management/'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof modulesUserManagementRoutesHomeIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/promotions/': {
      id: '/_main-ui/_protected/promotions/'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof modulesPromotionsRoutesHomeIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/import-export-settings/': {
      id: '/_main-ui/_protected/import-export-settings/'
      path: '/import-export-settings'
      fullPath: '/import-export-settings'
      preLoaderRoute: typeof modulesImportExportSettingsRoutesIndexIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/email-settings/': {
      id: '/_main-ui/_protected/email-settings/'
      path: '/email-settings'
      fullPath: '/email-settings'
      preLoaderRoute: typeof modulesEmailSettingsRoutesIndexIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/dashboard-settings/': {
      id: '/_main-ui/_protected/dashboard-settings/'
      path: '/dashboard-settings'
      fullPath: '/dashboard-settings'
      preLoaderRoute: typeof modulesDashboardSettingsRoutesDashboardIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/analytics/': {
      id: '/_main-ui/_protected/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof modulesAnalyticsRoutesIndexIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/promotions/edit/$id': {
      id: '/_main-ui/_protected/promotions/edit/$id'
      path: '/promotions/edit/$id'
      fullPath: '/promotions/edit/$id'
      preLoaderRoute: typeof modulesPromotionsRoutesEditIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
    '/_main-ui/_protected/promotions/duplicate/$id': {
      id: '/_main-ui/_protected/promotions/duplicate/$id'
      path: '/promotions/duplicate/$id'
      fullPath: '/promotions/duplicate/$id'
      preLoaderRoute: typeof modulesPromotionsRoutesDuplicateIndexRouteImport
      parentRoute: typeof modulesCoreRoutesProtectedIndexRoute
    }
  }
}

interface modulesAuthRoutesAuthIndexRouteChildren {
  modulesAuthRoutesLoginIndexRoute: typeof modulesAuthRoutesLoginIndexRoute
}

const modulesAuthRoutesAuthIndexRouteChildren: modulesAuthRoutesAuthIndexRouteChildren =
  {
    modulesAuthRoutesLoginIndexRoute: modulesAuthRoutesLoginIndexRoute,
  }

const modulesAuthRoutesAuthIndexRouteWithChildren =
  modulesAuthRoutesAuthIndexRoute._addFileChildren(
    modulesAuthRoutesAuthIndexRouteChildren,
  )

interface modulesCoreRoutesProtectedIndexRouteChildren {
  modulesCoreRoutesHomeIndexRoute: typeof modulesCoreRoutesHomeIndexRoute
  modulesAnalyticsRoutesIndexIndexRoute: typeof modulesAnalyticsRoutesIndexIndexRoute
  modulesDashboardSettingsRoutesDashboardIndexRoute: typeof modulesDashboardSettingsRoutesDashboardIndexRoute
  modulesEmailSettingsRoutesIndexIndexRoute: typeof modulesEmailSettingsRoutesIndexIndexRoute
  modulesImportExportSettingsRoutesIndexIndexRoute: typeof modulesImportExportSettingsRoutesIndexIndexRoute
  modulesPromotionsRoutesHomeIndexRoute: typeof modulesPromotionsRoutesHomeIndexRoute
  modulesUserManagementRoutesHomeIndexRoute: typeof modulesUserManagementRoutesHomeIndexRoute
  modulesPromotionsRoutesDetailsIndexRoute: typeof modulesPromotionsRoutesDetailsIndexRoute
  modulesPromotionsRoutesCreateIndexRoute: typeof modulesPromotionsRoutesCreateIndexRoute
  modulesPromotionsRoutesDuplicateIndexRoute: typeof modulesPromotionsRoutesDuplicateIndexRoute
  modulesPromotionsRoutesEditIndexRoute: typeof modulesPromotionsRoutesEditIndexRoute
}

const modulesCoreRoutesProtectedIndexRouteChildren: modulesCoreRoutesProtectedIndexRouteChildren =
  {
    modulesCoreRoutesHomeIndexRoute: modulesCoreRoutesHomeIndexRoute,
    modulesAnalyticsRoutesIndexIndexRoute:
      modulesAnalyticsRoutesIndexIndexRoute,
    modulesDashboardSettingsRoutesDashboardIndexRoute:
      modulesDashboardSettingsRoutesDashboardIndexRoute,
    modulesEmailSettingsRoutesIndexIndexRoute:
      modulesEmailSettingsRoutesIndexIndexRoute,
    modulesImportExportSettingsRoutesIndexIndexRoute:
      modulesImportExportSettingsRoutesIndexIndexRoute,
    modulesPromotionsRoutesHomeIndexRoute:
      modulesPromotionsRoutesHomeIndexRoute,
    modulesUserManagementRoutesHomeIndexRoute:
      modulesUserManagementRoutesHomeIndexRoute,
    modulesPromotionsRoutesDetailsIndexRoute:
      modulesPromotionsRoutesDetailsIndexRoute,
    modulesPromotionsRoutesCreateIndexRoute:
      modulesPromotionsRoutesCreateIndexRoute,
    modulesPromotionsRoutesDuplicateIndexRoute:
      modulesPromotionsRoutesDuplicateIndexRoute,
    modulesPromotionsRoutesEditIndexRoute:
      modulesPromotionsRoutesEditIndexRoute,
  }

const modulesCoreRoutesProtectedIndexRouteWithChildren =
  modulesCoreRoutesProtectedIndexRoute._addFileChildren(
    modulesCoreRoutesProtectedIndexRouteChildren,
  )

interface modulesCoreRoutesMainUiIndexRouteChildren {
  modulesCoreRoutesProtectedIndexRoute: typeof modulesCoreRoutesProtectedIndexRouteWithChildren
}

const modulesCoreRoutesMainUiIndexRouteChildren: modulesCoreRoutesMainUiIndexRouteChildren =
  {
    modulesCoreRoutesProtectedIndexRoute:
      modulesCoreRoutesProtectedIndexRouteWithChildren,
  }

const modulesCoreRoutesMainUiIndexRouteWithChildren =
  modulesCoreRoutesMainUiIndexRoute._addFileChildren(
    modulesCoreRoutesMainUiIndexRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  modulesAuthRoutesAuthIndexRoute: modulesAuthRoutesAuthIndexRouteWithChildren,
  modulesCoreRoutesMainUiIndexRoute:
    modulesCoreRoutesMainUiIndexRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
